<template>
    <div class="p-3">
        <b-alert show variant="danger">{{ $t("message.multipleSession") }}</b-alert>
    </div>
</template>

<script>
export default {
    name: "MultiSessionDenied",
};
</script>

<style scoped></style>
